import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({ name: 'timeAgo' })
export class TimeAgoPipe implements PipeTransform {
    transform(value: string | Date): string {
        return moment(moment.utc(value)).fromNow();
    }
}
